import { useState } from "react";
import { tv } from "tailwind-variants";

interface RelationTabsProps {
  tabs: {
    label: React.ReactNode;
    component: React.ReactNode;
  }[];
}

const relationTabs = tv({
  slots: {
    tab: "line-clamp-2 h-[40px] leading-[20px]  text-[#000] dark:text-[#fff] cursor-pointer",
  },
  variants: {
    active: {
      true: {
        tab: "text-[#000] dark:text-[#fff]",
      },
      false: {
        tab: "text-[#666] dark:text-[#fff]",
      },
    },
  },
})();

export const RelationTabs = ({ tabs }: RelationTabsProps) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  const content = tabs[activeTab].component;

  return (
    <div>
      <div className="border-t border-b border-dashed  border-t-[#e7e7e7] dark:border-t-[#272727] dark:border-b-[#272727] flex flex-wrap md:grid-cols-2 mt-[20px] pt-[20px] gap-[10px] mb-[15px]">
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={relationTabs.tab({
              active: activeTab === index,
            })}
            onClick={() => handleTabClick(index)}
          >
            {tab.label}
          </div>
        ))}
      </div>
      <div>{content}</div>
    </div>
  );
};
